// Sessions created before the name fix stored "null null" (or "John null")
// as the contact name. Drop those placeholder tokens rather than sending them.
const PLACEHOLDER_NAME_TOKENS = new Set(['null', 'undefined']);

/**
 * Removes placeholder tokens from a stored full name. Returns null when
 * nothing real is left (or the value is not a string), so callers can apply
 * their own fallback.
 */
export const cleanFullName = (name?: unknown): string | null =>
  (typeof name === 'string' ? name : '')
    .split(/\s+/)
    .filter(part => part && !PLACEHOLDER_NAME_TOKENS.has(part))
    .join(' ') || null;
